import { useState, useEffect } from "react";
import Card from "./Card.js";
import { getMUICache, getUrl, appendStyleSheet, getEndpoint, setCmsSeoData, addDataPosition, refreshTheAd, getImageUrl, getImageSize, convertEpochTime, fetchAnchorValue, isCSR, validateAndUpdateLpParam, getItemsPerPage, getAdSlotListCount, insertAdSlot } from '../../../common/utils.js';
import { CacheProvider } from '@emotion/react';
// import Pagination from '@mui/material/Pagination';
import PaginationThree from "../../ThemeThree/PaginationThree/PaginationThree.js"
// import Box from '@mui/material/Box';
// import Container from '@mui/material/Container';
// import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link'
import "./ListViewTwo.css";
import { PAGEBUILDER_URLS } from "../../Common/Constant.js";
import bcrypt from 'bcryptjs-react';
import { EagerLoadImages, AddImageDimensions, SetHighPriorityImages, PreloadViewportImages, ImageLoader } from '../../../components/IntersectionObserver/imageComponent';
// import { isMobile, isDesktop } from "react-device-detect";

ListViewTwo.version = 1000;

ListViewTwo.lang = 'en';
ListViewTwo.langs = [
  'en'
];
ListViewTwo.setLang = (lang: any) => {
  ListViewTwo.lang = lang;
}

Object.defineProperty(ListViewTwo, 'name', {
  writable: true,
  value: 'ListViewTwo'
});


export function ListViewTwo(props: any) {
  const [cardListData, setCardListData] = useState<any>([]);
  const [currentPageData, setCurrentPageData] = useState<any>([]);
  const [paginationMetaData, setPaginationData] = useState<any>({});
  const [currentPageIndex, setCurrentPageIndex] = useState<any>(1);
  const [seoPageData, setSeoPageData] = useState<any>({});
  const [l1PageData, setl1PageData] = useState<any>({});
  const [refreshAdPg, setRefreshAdPg] = useState<any>(1);

  const {
    mobileView,
    showDateTime,
    showAuthorName,
    background,
    type1 = "page",
    showAdSlot,
    isSimilarStories,
    showViewport,
    anchorLinksValue,
    itemsPerPage
  } = props;

  var { imagesInViewport } = props;
  const listItemsPerPage = getItemsPerPage(10, itemsPerPage);
  const adSlotListCount = getAdSlotListCount("List View Three", listItemsPerPage);

  const endpoint = getEndpoint(props, "MAIN");
  const seoEndpoint = getEndpoint(props, "SEO_URL");
  const endpointSH = getEndpoint(props, "LISTING_SH_URL");

  useEffect(() => {
    if (!endpoint.isSSR || !endpoint.SSRDataObj) {
      fetchComponentData();
    }
    // if(!id && type1 == "page") {
    //   setURLSearchParam(1);
    // }
  }, [type1, endpoint, showAdSlot])

  // const [clientDevice, setClientDevice] = useState({ isDesktop: false, isMobile: false });
  // useEffect(() => {
  //     setClientDevice({ isDesktop, isMobile });
  // }, []);

  // useEffect(() => {
  //   if (clientDevice.isDesktop && props.bodyAdScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  //   if (clientDevice.isMobile && props.bodyAdMobileScript) {
  //       const adContainer = document.getElementById("ad-container");
  //       if (adContainer) {
  //           const script = document.createElement("script");
  //           script.async = true;
  //           script.innerHTML = props.bodyAdMobileScript.match(/<script[^>]*>([\s\S]*?)<\/script>/)?.[1] || "";
  //           adContainer.appendChild(script);
  //       }
  //   }
  // }, [clientDevice.isDesktop, clientDevice.isMobile, props.bodyAdScript, props.bodyAdMobileScript]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gpEditor) {

      window.gpEditor.editor.on('component:selected', (component: any) => {
        if (component && component.attributes && (component.attributes.type === "List View Two") && props.name === "List View Two") {
          setTimeout(() => {
            const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
            if (trait && trait.el) {
              // Show trait element if showAdSlot is true, hide otherwise
              trait.el.style.display = props.showAdSlot ? 'block' : 'none';
            }
          }, 200);
        }

        // if (component && component.attributes && (component.attributes.type === "Similar Stories") && props.name === "Similar Stories") {
        //   setTimeout(() => {
        //     const trait = component.getTraits().find((tr: any) => tr.get('id') === "deviceType");
        //     if (trait && trait.el) {
        //       // Show trait element if showAdSlot is true, hide otherwise
        //       trait.el.style.display = props.showAdSlot ? 'block' : 'none';
        //     }
        //   }, 200);
        // }

      });

      const selected = window.gpEditor.getSelected();
      if (selected) {
        const trait = selected.getTraits().find((tr: any) => tr.get('id') === "deviceType");
        if (trait && trait.el) {
          // Show trait element if showAdSlot is true, hide otherwise
          trait.el.style.display = props.showAdSlot ? 'block' : 'none';
        }
      }
    }
  }, [endpoint, props.showAdSlot, props.adSize]);


  AddImageDimensions();
  SetHighPriorityImages();
  PreloadViewportImages();
  ImageLoader();
  useEffect(() => {
    EagerLoadImages();
  }, []);

  if (endpointSH && endpointSH.isSSR && endpointSH.SSRDataObj && l1PageData && Object.keys(l1PageData).length === 0 && endpointSH.SSRDataObj.pg && Object.keys(endpointSH.SSRDataObj.pg).length != 0) {
    setl1PageData(endpointSH.SSRDataObj || { items: [] });
  }


  let styles = require("./ListViewTwo.css");
  appendStyleSheet("ListViewTwo", styles);

  let defaultUrl: any = "";
  if (typeof window !== 'undefined' && undefined !== window && window) {
    defaultUrl = window.location.href;
    if (defaultUrl) { defaultUrl = validateAndUpdateLpParam(defaultUrl); }
  } else {
    defaultUrl = props && "https://" + props.REQUEST_HOSTNAME + props.REQUEST_URL;
  }


  let pageId = 1;
  if (defaultUrl) {
    try {
      let id = new URL(defaultUrl).searchParams.get("lp");
      pageId = type1 == "page" && id ? parseInt(id) : 1;
    } catch (error) {
      //console.log("error", error);
      pageId = 1;
    }

  }

  const setData = (val: any) => {
    if (type1 == "page") {
      const obj: pageData = { page: pageId, items: val?.items };
      setCardListData([obj]);
    } else {
      setCardListData(val?.items)
    }

    setCurrentPageIndex(pageId);
    setCurrentPageData(val?.items);
    let ct: any = val?.pg?.tp;
    try { if (val?.pg?.tp) ct = parseInt(val.pg.tp); } catch (error) { //console.log("error", error); 
    }
    setPaginationData({ count: ct });

    if (typeof props.exportedKeys !== "undefined" && typeof props.exportedKeys.pid !== "undefined"
      && val?.items?.length > 0) {
      props.exportedKeys.pid = val.items[0].pid;
    }
  }

  if (seoEndpoint !== undefined && seoEndpoint && seoEndpoint.isSSR && seoEndpoint.SSRDataObj
    && seoPageData !== undefined && seoPageData && Object.keys(seoPageData).length === 0 && seoEndpoint.SSRDataObj.pg && Object.keys(seoEndpoint.SSRDataObj.pg).length != 0
    && seoEndpoint.SSRDataObj.pg.tr != 'null' && seoEndpoint.SSRDataObj.items && seoEndpoint.SSRDataObj.items.length != 0) {
    setCmsSeoData(props, seoEndpoint.SSRDataObj.items[0], "ListView");
    setSeoPageData(seoEndpoint.SSRDataObj.items[0]);
  }

  if (endpoint !== undefined && endpoint && endpoint.isSSR && endpoint.SSRDataObj
    && (!currentPageData || Object.keys(currentPageData).length === 0) && (!cardListData || Object.keys(cardListData).length === 0)
    && endpoint.SSRDataObj.pg && Object.keys(endpoint.SSRDataObj.pg).length != 0 && endpoint.SSRDataObj.pg.tr != 'null') {
    setData(endpoint.SSRDataObj);
  }



  const clearSSR = () => {
    endpoint.SSRDataObj = null;
  }

  interface pageData {
    page: number;
    items: any; // Replace YourItemType with the actual type of items
    // Add more properties as needed
  }

  const fetchComponentData = () => {
    setCardListData([]);
    setCurrentPageData([]);
    setCurrentPageIndex(1);

    let url = getUrl(props, pageId);
    setCurrentPageIndex(pageId);

    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(url, { headers: headers })
      .then(data => data.json())
      .then(parsedData => {
        setData(parsedData);
      })
      .catch(() => {
        //console.log("error")
      })
  }



  const getAnotherPageData = (val: number, isLoadMore: boolean) => {
    let url = getUrl(props, val, isLoadMore);

    let headerString = '?' + url.split("?")[1];
    headerString = bcrypt.hashSync(headerString, 6);
    const headers = { 'p-nonce': headerString };

    fetch(url, { headers: headers })
      .then(data => data.json())
      .then(value => {
        if (type1 == "page") {
          let obj: pageData = { page: val, items: value?.items };

          setCardListData([...cardListData, obj])
          setCurrentPageData(value?.items);
        } else {
          setCardListData([...cardListData, ...value?.items])
          type1 == "load" ? setCurrentPageData([...cardListData, ...value?.items]) : setCurrentPageData(value?.items);
          setCurrentPageIndex(currentPageIndex + 1)
        }
      })
  }

  const handleLoadMoreData = (data: any) => {
    let finalData: any = [];

    for (let i = 0; i < data.length; i++) {
      if ((i !== 1 && i % listItemsPerPage === 1) || i === 2) {
        // Add a blank element at the 3rd position
        finalData.push("", data[i]);
      } else {
        finalData.push(data[i]);
      }
    }
    return finalData;
  }

  const renderCardList = () => {
    if (!Array.isArray(currentPageData)) {
      console.error('currentPageData is not an array or is undefined');
      return [];
    }
    let listData = [];

    let renderData = [...currentPageData];

    if (showAdSlot && props.adNetwork === "google" && currentPageIndex === 1) {
      renderData.splice(3, 0, "");
    } else if (showAdSlot && props.adNetwork === "google" && currentPageIndex > 1 && type1 === "load") {
      renderData.splice(3, 0, "");
    } else if (showAdSlot && props.adNetwork === "can") {
      if (renderData.length >= 5 && type1 != "load") {
        renderData.splice(3, 0, "")
      }

      if (renderData.length >= 5 && type1 == "load") {
        renderData = handleLoadMoreData(renderData);
      }
    }

    let bodySnippet: any;
    if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
      if (isSimilarStories) {
        bodySnippet = '<div class="addmImageSize"></div> <div class="admTextContainer" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #f0f0f0;"><div class="ad-box" style="height:83px;display: flex;align-items: center;justify-content: center;">Ad Slot<br>330 X 83</div></div>'
      } else {
        let resolution = `781 X 159`;
        let imgResolution = `212 x 159`
        if ((window as any).gpEditor && (window as any).gpEditor.getDevice() === 'Mobile portrait') {
          resolution = `330 X 90`;
          imgResolution = `120 x 90`
        }
        bodySnippet = `<div class="listAdsWrapper" style="display: flex;border: .5px solid #D5D5D5;width: 100%;"><div class="addImageSize" style="width: 212px;height: 159px; display: flex; flex-shrink: 0; margin-right: 27px;  overflow: hidden; background: #f0f0f0; align-items: center; justify-content: center;">${imgResolution}</div> <div class="adTextContainer" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%; background-color: #fff;"><div class="ad-box" style="height:159px;display: flex;align-items: center;justify-content: center;">Ad Slot<br>${resolution}</div></div></div>`
      }
    }
    else if (isCSR()) {
      console.log("Only CSR");
      // if (clientDevice.isDesktop) {
      //     bodySnippet = `<div id="ad-container">${props.bodyAdScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // } else if (clientDevice.isMobile) {
      //     bodySnippet = `<div id="ad-container">${props.bodyAdMobileScript?.replace(/<script[^>]*>[\s\S]*?<\/script>/, "")}</div>`;
      // }
      bodySnippet = props?.data?.attributes?.adConfigurations;
    }
    else {
        console.log("Only SSR");
        // bodySnippet = `<div></div>`;
        bodySnippet = props?.data?.attributes?.adConfigurations;
    }

    var isViewport = false;
    if (!showViewport) { imagesInViewport = 0; }
    else {
      if (typeof imagesInViewport === 'string' && imagesInViewport.toUpperCase() === "ALL") {
        imagesInViewport = renderData.length;
      } else if (typeof imagesInViewport === 'string' && !isNaN(parseInt(imagesInViewport))) {
        imagesInViewport = parseInt(imagesInViewport);
      } else { imagesInViewport = 0; }
    }

    for (var i = 0; i < renderData.length; i++) {
      if (renderData[i] == "") {
        const Id = "ad-list-" + currentPageIndex + "_" + i;
        let pageIndex = currentPageIndex + i
        let rerender = true;
        if (type1 === "load") {
          pageIndex = 1 + i;
          rerender = false;
          if (renderData.lastIndexOf("") === i) {
            rerender = true;
          }
        }

        let finalBody: String = "";
        if (isCSR() && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url))) {
          finalBody = addDataPosition(bodySnippet, pageIndex);
          listData.push(<div key={i} id={Id} className={isSimilarStories ? "nh-" + currentPageIndex + "_" + i + " listcontainer themeTwoListViewWraper" : "mh-" + currentPageIndex + "_" + i + " listcontainer themeTwoListViewWraper"} dangerouslySetInnerHTML={{ __html: finalBody }}></div>)

        } else {
          listData.push(<div key={i} id={Id} className={isSimilarStories ? "nh-" + currentPageIndex + "_" + i + " listcontainer themeTwoListViewWraper" : "mh-" + currentPageIndex + "_" + i + " listcontainer themeTwoListViewWraper"}>{insertAdSlot(i, bodySnippet, props.name)}</div>)
        }

        //refresh the colombia ad
        if (!isSimilarStories && showAdSlot && rerender) {
          refreshTheAd(finalBody, refreshAdPg, setRefreshAdPg, currentPageIndex);
        }
      } else {
        if (imagesInViewport > i) { isViewport = true; }
        else { isViewport = false; }
        listData.push(<Card
          item={renderData[i]}
          showDateTime={showDateTime}
          mobileView={mobileView}
          showAuthorName={showAuthorName}
          background={background}
          key={i}
          isSimilarStories={isSimilarStories}
          CONSTANTS={props.CONSTANTS}
          isViewport={isViewport}
          cardTextColor={props.cardTextColor}
          cardColor={props.cardColor}
          showAuthor={props.showAuthor}
          showDate={props.showDate}
          anchorLinksValue={anchorLinksValue}
        />)
      }
    }

    return listData;
  }

  const handlePrevBtnClick = () => {
    if (currentPageIndex == 1) {
      return;
    } else {
      clearSSR();
      let currentpagedata = [...cardListData];
      let dataLength = showAdSlot && (props.adNetwork === "can" || (props.adNetwork === "google" && currentPageIndex === 1)) ? adSlotListCount : listItemsPerPage;
      let updatedArr = currentpagedata.splice(dataLength * (currentPageIndex - 2), dataLength);
      setCurrentPageData(updatedArr);
      setCurrentPageIndex(currentPageIndex - 1)
    }
  }

  const handleNextBtnClick = () => {
    clearSSR();
    let dataLength = showAdSlot && (props.adNetwork === "can" || (props.adNetwork === "google" && currentPageIndex === 1)) ? adSlotListCount : listItemsPerPage;

    if (cardListData.length >= (dataLength * currentPageIndex) + 1) {
      let currentpagedata = [...cardListData];
      let lastItem = cardListData.length - (dataLength * currentPageIndex) > dataLength ? dataLength : cardListData.length - (dataLength * currentPageIndex);
      let updatedArr = currentpagedata.splice((dataLength * currentPageIndex), lastItem);
      setCurrentPageData(updatedArr);
      setCurrentPageIndex(currentPageIndex + 1)

    } else {
      getAnotherPageData(currentPageIndex + 1, false);
    }
  }

  const dataAvailable = (pageIndex: number) => {
    let currentDataAvailable = false;
    let currentData = [...cardListData];

    for (var i = 0; i < currentData.length; i++) {
      if (currentData[i].page == pageIndex) {
        return currentData[i].items;
      }
    }
    return currentDataAvailable;
  }

  const setURLSearchParam = (index: any) => {
    if (typeof window !== 'undefined' && undefined !== window && window) {
      let url = new URL(window.location.href);
      url.searchParams.set("lp", index);
      window.history.pushState({ path: url.href }, '', url.href);
    }
  }

  const handlePaginationChange = (event: any, index: number) => {
    clearSSR();
    let isSelectedPageAvailable = dataAvailable(index);

    if (isSelectedPageAvailable) {
      setCurrentPageData(isSelectedPageAvailable);
    } else {
      getAnotherPageData(index, false);
    }
    setURLSearchParam(index);
    setCurrentPageIndex(index);
  }

  const handleLoadMoreClick = () => {
    clearSSR();
    getAnotherPageData(currentPageIndex + 1, false)
  }

  const renderPagination = () => {
    return <PaginationThree
      type={type1}
      handlePaginationChange={handlePaginationChange}
      paginationMetaData={paginationMetaData}
      handleNextBtnClick={handleNextBtnClick}
      handlePrevBtnClick={handlePrevBtnClick}
      handleLoadMoreClick={handleLoadMoreClick}
      currentPageIndex={currentPageIndex}
    />
  }

  const isL1 = (pageData: any) => {
    if (pageData && pageData.items && Array.isArray(pageData.items) && pageData.items.length > 0) {
      return true
    }
    return false
  }
  //knowledge-search


  return (
    <div>
      {isL1(l1PageData) ? (
        (props.dataMappingTrait?.mappingType !== 'h' &&
          props.dataMappingTrait?.mappingType !== 'lh' &&
          props.dataMappingTrait?.mappingType !== 'p') ? (
          <div className={`card_wrapper manage-list-pagination ${isSimilarStories ? "similarstoriespage" : ""}`} style={{ backgroundColor: props.cardBgColor }}>
            <CacheProvider value={getMUICache()}>
              <div className='ThemeTwoListViewHeadingWrap'>
                <p className='ThemeTwoListViewHeading themeTwoCommonComponentsHeading'>
                  <a href={props.mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, props.mainHeadingHref)} style={{ color: props.mainHeadingColor }}>{props.mainHeading}</a></p>
              </div>
              {currentPageData && renderCardList()}
              {currentPageData && !isSimilarStories && Object.keys(paginationMetaData).length > 0 && renderPagination()}
            </CacheProvider>
          </div>

        ) : (
          l1PageData?.items.map((value: any, index: any) => (
            <div key={index} className="ThemeThreeOtherListViewWrapper dfe">
              <div className="ThemeThreeOtherListHeader">
                <div className="ThemeThreeOtherListSecname">
                  <Link href={value.wu} target={fetchAnchorValue(anchorLinksValue, value.wu)} >{value?.hl}</Link>
                </div>
                <div className="ThemeThreeOtherListViewall">
                  <Link href={value.wu} target={fetchAnchorValue(anchorLinksValue, value.wu)} >View All</Link>
                </div>
              </div>
              <div className="ThemeThreeOtherListViewMainWrap">
                {Array.isArray(value.children) && value.children.length > 0 && (
                  <>
                    <div className="ThemeThreeOtherListViewLeftSide">
                      <Link
                        href={value.children[0].wu}
                        style={{ color: props.mainHeadingColor }}
                        target={fetchAnchorValue(anchorLinksValue, value.children[0].wu)}
                        className='ThemeThreeOtherListViewCardWrap'
                      >
                        <div className='ThemeThreeOtherListViewCardWrap'>
                          <div className='ThemeThreeOtherListViewCardImgWrap'>
                            <picture>
                              <source media="(min-width: 768px)"
                                srcSet={getImageUrl(value.children[0].id, getImageSize(value.children[0].imageid), 504, 378, "", false, props.CONSTANTS, '8')} />
                              <source media="(max-width: 767px)"
                                srcSet={getImageUrl(value.children[0].id, getImageSize(value.children[0].imageid), 328, 246, "", false, props.CONSTANTS, '8')} />
                              <img alt={value.children[0]?.hl?.slice(0, 25)} title={value.children[0]?.hl?.slice(0, 25)} loading="lazy" />
                            </picture>
                          </div>
                          <div className='themeThreedateAgencyWrap'>
                            {props.showDate && <p className='ThemeThreeCommonAuthorWrapper'>{convertEpochTime(value.children[0].lpt, 'updated', "DD MMM YYYY")}</p>}
                            {props.showAuthor && <p className='themeThreeHeroLayoutDateTimeAgency'>By <span className='manageAuthorName'>{value.children[0].au}</span></p>}
                          </div>
                          <div className='ThemeThreeOtherListViewContentWrap'>
                            <p className='ThemeThreeOtherListViewDiscription'>{value.children[0].hl}</p>
                          </div>
                          <div className='ThemeThreeOtherListViewSumWrap'>
                            <p className='ThemeThreeOtherListViewSummry'>{value.children[0].syn}</p>
                          </div>
                        </div>
                      </Link>
                    </div>
                    {value.children.length > 1 && (
                      <div className="ThemeThreeOtherListViewRightSide">
                        {value.children.slice(1, 3).map((valItem: any, subindex: any) => (
                          <Link
                            href={valItem.wu}
                            key={`2_${subindex}`}
                            style={{ color: props.mainHeadingColor }}
                            target={fetchAnchorValue(anchorLinksValue, valItem.wu)}
                            className='ThemeThreeOtherListViewCardWrap'
                          >
                            <div className='ThemeThreeOtherListViewCardWrap' style={{ backgroundColor: props.cardActiveColor }}>
                              <div className='ThemeThreeOtherListViewCardImgWrap'>
                                {/* <img
                                  src={getImageUrl(valItem.id, getImageSize(valItem.imageid), 280, 210, "", false, props.CONSTANTS)}
                                  alt={valItem?.hl?.slice(0, 25)}
                                  title={valItem?.hl?.slice(0, 25)}
                                /> */}

                                <picture>
                                  <source media="(min-width: 768px)"
                                    srcSet={getImageUrl(valItem.id, getImageSize(valItem.imageid), 231, 173, "", false, props.CONSTANTS, '8')} />
                                  <source media="(max-width: 767px)"
                                    srcSet={getImageUrl(valItem.id, getImageSize(valItem.imageid), 156, 117, "", false, props.CONSTANTS, '8')} />
                                  <img alt={valItem?.hl?.slice(0, 25)} title={valItem?.hl?.slice(0, 25)} loading="lazy" />
                                </picture>

                              </div>
                              <div className='ThemeThreeOtherListViewContentWrap'>
                                <p className='ThemeThreeOtherListViewDiscription'>{valItem.hl}</p>
                              </div>
                              <div className='themeThreedateAgencyWrap'>
                                <p className='ThemeThreeCommonAuthorWrapper'>{convertEpochTime(valItem.lpt, 'updated', "DD MMM YYYY")}</p>
                                {props.showAuthor && <p className='themeThreeHeroLayoutDateTimeAgency'>By <span className='manageAuthorName'>{valItem.au}</span></p>}
                              </div>
                            </div>
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
              {Array.isArray(value.children) && value.children.length > 2 && (
                <div className="OtherListViewFourSlide">
                  {value.children.slice(3, 7).map((valItem: any, subindex: any) => (
                    <Link
                      href={valItem.wu}
                      key={`2_${index}_${subindex}`}
                      target={fetchAnchorValue(anchorLinksValue, valItem.wu)}
                      className='ThemeThreeOtherListViewCardWrap'
                    >
                      <div className='ThemeThreeOtherListViewCardWrap' style={{ backgroundColor: props.cardActiveColor }}>
                        <div className='ThemeThreeOtherListViewCardImgWrap ThemeTwoBottomOtherListViewCardImgWrap'>
                          <picture>
                            <source media="(min-width: 768px)"
                              srcSet={getImageUrl(valItem.id, getImageSize(valItem.imageid), 175, 131, "", false, props.CONSTANTS, '8')} />
                            <source media="(max-width: 767px)"
                              srcSet={getImageUrl(valItem.id, getImageSize(valItem.imageid), 156, 117, "", false, props.CONSTANTS, '8')} />
                            <img alt={valItem?.hl?.slice(0, 25)} title={valItem?.hl?.slice(0, 25)} loading="lazy" />
                          </picture>
                        </div>
                        <div className='ThemeThreeOtherListViewContentWrap'>
                          <p className='ThemeThreeOtherListViewDiscription'>{valItem.hl}</p>
                        </div>
                        <div className='themeThreedateAgencyWrap'>
                          <p className='ThemeThreeCommonAuthorWrapper'>{convertEpochTime(valItem.lpt, 'updated', "DD MMM YYYY")}</p>
                          {props.showAuthor && <p className='themeThreeHeroLayoutDateTimeAgency'>By <span className='manageAuthorName'>{valItem.au}</span></p>}
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))
        )
      ) : cardListData ? (
        <div className={`card_wrapper manage-list-pagination ${isSimilarStories ? "similarstoriespage" : ""}`} style={{ backgroundColor: props.cardBgColor }}>
          <CacheProvider value={getMUICache()}>
            <div className='ThemeTwoListViewHeadingWrap'>
              <p className='ThemeTwoListViewHeading themeTwoCommonComponentsHeading'><a href={props.mainHeadingHref} target={fetchAnchorValue(anchorLinksValue, props.mainHeadingHref)} style={{ color: props.mainHeadingColor }}>{props.mainHeading}</a></p>
            </div>
            {currentPageData && renderCardList()}
            {currentPageData && !isSimilarStories && Object.keys(paginationMetaData).length > 0 && renderPagination()}
          </CacheProvider>
        </div>
      ) : null}
    </div>
  );

}

